import { render } from "./MoonPhase.vue?vue&type=template&id=008f3093&scoped=true"
import script from "./MoonPhase.vue?vue&type=script&lang=js"
export * from "./MoonPhase.vue?vue&type=script&lang=js"

import "./MoonPhase.vue?vue&type=style&index=0&id=008f3093&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-008f3093"]])

export default __exports__